import { render } from "./OrderSupplierTabMain.vue?vue&type=template&id=306008c7"
import script from "./OrderSupplierTabMain.vue?vue&type=script&lang=js"
export * from "./OrderSupplierTabMain.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__